import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters, mapActions } from 'vuex';
import u8Sidebar from './sidebar';
import u8Header from './header';
export default {
  name: 'u8-layout',
  components: {
    u8Sidebar: u8Sidebar,
    u8Header: u8Header
  },
  data: function data() {
    return {
      // [侧边栏宽度] 正常状态
      sidebarWidth: '200px',
      // [侧边栏宽度] 折叠状态
      sidebarWidthCollapsed: '65px',
      transitionActive: true,
      keepAlive: [],
      // 当前页面路径
      steps: []
    };
  },
  watch: {
    '$route.matched': {
      handler: function handler(val) {
        this.steps = [];
        var currRoute = val[val.length - 1];

        if (currRoute && currRoute.meta && currRoute.meta.breadcrumb == 0) {
          // 不显示breadcrumb
          return;
        } else {
          if (currRoute && currRoute.meta && currRoute.meta !== undefined && currRoute.meta.title && currRoute.meta.title !== undefined) {
            if (currRoute.meta.steps && currRoute.meta.steps !== undefined && currRoute.meta.steps.length > 0) {
              this.steps = this.steps.concat(currRoute.meta.steps);
            }

            this.steps.push(currRoute.meta.title);
          }
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.set(this.themeActiveSetting.name);
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('u8sdk', {
    themeActiveSetting: 'theme/activeSetting'
  })), mapState('u8sdk/menu', {
    collapse: function collapse(state) {
      return state.collapse;
    }
  })),
  methods: _objectSpread({}, mapActions('u8sdk/theme', ['set']))
};